export var componentsLocales = {
  loading: 'Загрузка'
};